import {
  useCancelOrganizationPaymentPlanPendingChangesMutation,
  useSendOrganizationPaymentPlanPendingChangesEmailMutation,
} from '@/services/organizations';
import { toast } from '@palmetto/palmetto-components';

export const useCancelPaymentPlanAction = (paymentPlan: { id: string }) => {
  const { id } = paymentPlan;
  const [cancelPaymentPlan, { isLoading: isCancelling }] = useCancelOrganizationPaymentPlanPendingChangesMutation();
  const handleCancelPaymentPlan = async () => {
    try {
      await cancelPaymentPlan({ settingsId: id }).unwrap();
      toast.success('Payment plan cancelled successfully');
    } catch (error) {
      console.error('Failed to cancel payment plan proposed change', error);
      toast.error('Failed to cancel payment plan proposed change');
    }
  };
  return { handleCancelPaymentPlan, isCancelling };
};

export const useResendPendingPaymentPlanEmail = (paymentPlan: { id: string }) => {
  const { id } = paymentPlan;
  const [sendEmail, { isLoading: isSendingEmail }] = useSendOrganizationPaymentPlanPendingChangesEmailMutation();
  const handleSendEmail = async () => {
    try {
      await sendEmail({ settingsId: id }).unwrap();
      toast.success('Payment plan email sent successfully');
    } catch (error) {
      console.error('Failed to send payment plan email', error);
      toast.error('Failed to send payment plan email');
    }
  };
  return { handleSendEmail, isSendingEmail };
};
